import { Box, Checkbox, Flex, Heading, TextField } from "monday-ui-react-core";
import { Tooltip } from "monday-ui-react-core";
import type { ChangeEvent } from "react";
import styled from "styled-components";

import iconThree from "../../../../assets/icons/group-706.svg";
import { postFixValidationError } from "../../utils";

const CloneOptionsWrapper = styled.div`
  box-sizing: border-box;
  padding-top: 0;
  padding-left: var(--spacing-medium);
  padding-right: var(--spacing-medium);
  width: 100%;
`;

const TextFieldWrapper = styled.div`
  width: 200px;
`;

export const DEFAULT_OPTIONS_STATE: CloneOptions = {
  addPostfix: false,
  copySubItems: false,
  copyUpdates: false,
  copyAttachments: false,
};

export const DEFAULT_POSTFIX = " - clone";

interface CloneOptionsProps {
  cloneOptions: CloneOptions;
  onOptionChange: (e: ChangeEvent<HTMLInputElement>) => void;
  postfix: string | undefined;
  onPostfixChange: (text: string) => void;
}

export interface CloneOptions {
  [key: string]: boolean;
}

export function CloneOptionsSection({ cloneOptions, onOptionChange, postfix, onPostfixChange }: CloneOptionsProps) {
  return (
    <CloneOptionsWrapper>
      <Box
        border={Box.borders.DEFAULT}
        rounded={Box.roundeds.SMALL}
        paddingX={Box.paddingXs.SMALL}
        paddingY={Box.paddingYs.SMALL}
      >
        <Flex
          direction={Flex.directions.COLUMN}
          align={Flex.align.START}
          gap={Flex.gaps.SMALL}
          style={{ padding: "8px" }}
        >
          <Flex direction={Flex.directions.ROW} style={{ height: "30px" }}>
            <img src={iconThree} alt="restricted access" />
            <Heading type={Heading.types.h5} value="Clone options" />
          </Flex>
          <Flex direction={Flex.directions.ROW} style={{ height: "30px", marginBottom: "15px" }} gap={Flex.gaps.MEDIUM}>
            <Flex
              direction={Flex.directions.ROW}
              align={Flex.align.START}
              style={{ height: "30px" }}
              gap={Flex.gaps.SMALL}
            >
              <Tooltip content="If this option is not selected, the original name of the item will be copied.">
                <StyledCheckBox
                  id="addPostfix"
                  disabled={false}
                  indeterminate={false}
                  checked={cloneOptions.addPostfix}
                  onChange={(e) => onOptionChange(e)}
                  label="Add postfix to the item name"
                />
              </Tooltip>
              <TextFieldWrapper>
                <TextField
                  size={TextField.sizes.MEDIUM}
                  value={postfix}
                  onChange={onPostfixChange}
                  validation={postFixValidationError(postfix)}
                  disabled={!cloneOptions.addPostfix}
                />
              </TextFieldWrapper>
            </Flex>
            {/*<Checkbox
              id="copySubItems"
              disabled={false}
              indeterminate={false}
              checked={cloneOptions.copySubItems}
              onChange={(e) => onOptionChange(e)}
              label="Clone subitems"
            />*/}
            <StyledCheckBox
              id="copyUpdates"
              disabled={false}
              indeterminate={false}
              checked={cloneOptions.copyUpdates}
              onChange={(e) => onOptionChange(e)}
              label="Clone updates"
            />
          </Flex>
          {/*<Flex direction={Flex.directions.ROW} style={{ height: "30px" }}>
            <Checkbox
              id="copyAttachments"
              disabled={false}
              indeterminate={false}
              checked={cloneOptions.copyAttachments}
              onChange={(e) => onOptionChange(e)}
              label="Clone files(attachments)"
            />
          </Flex>*/}
        </Flex>
      </Box>
    </CloneOptionsWrapper>
  );
}

const StyledCheckBox = styled(Checkbox)`
  padding-top: 8px;
`;
